<div
    class="app-view-selected-label"
    [ngStyle]="{
        'background-color': getLabelTransparentBackgroundColor(),
        'border-color': label.color,
    }">
    <div
        class="app-view-selected-label-container"
        [matTooltip]="getLabelNote()"
        matTooltipClass="tooltip-container"
        matTooltipPosition="below"
        tooltip="tooltip">
        <div class="app-view-selected-label-container-text">
            {{ labelBinding.label.displayName | beautifyDisplayString }}
        </div>
        <img *ngIf="canBeRemoved" src="assets/images/common/cancel-hollow.svg" (click)="clearSingleOption()" />
    </div>
</div>
